import { useContext } from 'preact/hooks';
import { InputGroupContext } from './InputGroupContext';

/**
 * Utility hook for consuming the InputGroupContext
 *
 * @returns The value of closest InputGroupContext provider
 */
function useInputGroupContext() {
  return useContext(InputGroupContext);
}

export { useInputGroupContext };
